import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { getDeclarationsSaga } from './getDeclarationsSaga';
import { clarifyDeclarationSaga } from './clarifyDeclarationSaga';
import { getDeclarationsDocumentsSaga } from './getDeclarationDocumentsSaga';
import { getPropertyDeductionsSaga } from './getPropertyDeductionsSaga';
import { getDeclarationsHistorySaga } from 'modules/Declarations/sagas/getDeclarationsHistorySaga';
import { resendDeclarationSaga } from 'modules/Declarations/sagas/resendDeclarationSaga';

export default function* declarationsSaga() {
  yield takeEvery(actionTypes.GET_DECLARATIONS, getDeclarationsSaga);
  yield takeEvery(actionTypes.CLARIFY_DECLARATION, clarifyDeclarationSaga);
  yield takeEvery(actionTypes.GET_DOCUMENTS, getDeclarationsDocumentsSaga);
  yield takeEvery(actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE, getPropertyDeductionsSaga);
  yield takeEvery(actionTypes.GET_HISTORY, getDeclarationsHistorySaga);
  yield takeEvery(actionTypes.RESEND_DECLARATION, resendDeclarationSaga);
}
